<template>
  <router-view v-if="!isLoading" />
</template>

<script setup>
import { watch } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { RouterView } from 'vue-router';

import { useAppConfigStore } from '@/stores/appConfig.js';

const configStore = useAppConfigStore();
const { isLoading, isAuthenticated } = useAuth0();

watch(
  isLoading,
  (isAuth0Loading) => {
    if (!isAuth0Loading && isAuthenticated.value && !configStore.isConfigured) {
      configStore.getConfig({ init: 'true' });
    }
  },
  { immediate: true }
);
</script>
